/* eslint-disable prettier/prettier */
import React, { useRef } from 'react';
import objstr from 'obj-str';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import Image from 'next/image';
import * as Types from '@/pages/mijn-carel-lurvink/catalogus/stores/types';
import styles from './Attributes.module.scss';

import type { Swiper as SwiperRef } from 'swiper';

interface IAttributes {
  attribute: Types.SelectableVariantAttribute;
  attributes: Types.VariantAttributes[];
  onAttributeChange: AppCallbackFn;
}

type IHandleAttributeChange = {
  type: string;
  attributeValue: Types.MappedAttribute;
};

export const Attributes = ({ attribute, attributes, onAttributeChange }: IAttributes) => {
  const swiperRef = useRef<SwiperRef>();

  const handleAttributeChange = ({ type, attributeValue }: IHandleAttributeChange) => {
    onAttributeChange({ type, attributeValue });
  };

  return (
    <div className={styles.variantOptions}>
      <div className="w-100">
      <Swiper
        onSwiper={(swiper: any) => {
          swiperRef.current = swiper;
        }}
        nested={true}
        modules={[Navigation]}
        navigation={{
          lockClass: 'd-none',
          disabledClass: 'disabled',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }}
        slidesPerView="auto"
        slidesOffsetBefore={36}
        slidesOffsetAfter={36}
        spaceBetween={16}
        observer
      >
        {attribute.values.map((attributeValue, idx: number) => {
          const { code, value, disabled = false, image = null } = attributeValue;

          const classNames = objstr({
            [styles.colorOption]: image,
            [styles.labelOption]: !image,
            //@ts-expect-error: TS trips over dynamic keys
            [styles.selected]: attributes[attribute.type] === code,
            [styles.disabled]: disabled,
            transition: true
          });

          return (
            <SwiperSlide key={`${code}-${value}${idx}`}>
              {image ? (
                <span className={classNames} onClick={() => handleAttributeChange({ type: attribute.type, attributeValue })} key={code}>
                  <Image src={image} alt={value} className={styles.colorOptionImage} width="28" height="28" />

                  <span className="tooltip"><span className="tooltip_text">{value}</span></span>
                </span>
              ) : (
                <span className={classNames} onClick={() => handleAttributeChange({ type: attribute.type, attributeValue })} key={code}>
                  <span>{value}</span>
                </span>
              )}
            </SwiperSlide>
          );
        })}


        <button className={'swiper-button-prev'} onClick={() => swiperRef?.current?.slidePrev()}></button>
        <button className={'swiper-button-next'} onClick={() => swiperRef?.current?.slideNext()}></button>
      </Swiper>
      </div>
    </div>
  );
};
